import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import dashboard from "../../../images/sidebar_icon/dashboard.png";
import profileIcons from "../../../images/employee/sidebar/profile.png";


import useStyles from "../styles";
import SidebarLink from "../components/SidebarLink/SidebarLink";

const EmployeeSidebar = ({ location, isSidebarOpened }) => {
  const classes = useStyles();
  const recruiterItems = [
    {
      id: 0,
      label: "Employee Status",
      link: "/app/dashboard",
      view: true,
      icon: (
        <Tooltip title="Employee Status" placement="right">
          <IconButton>
            <img
              src={dashboard}
              alt="dashboard"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 1,
      label: "Profile",
      link: "/app/emp-info?&tab=0",
      view: true,
      icon: (
        <Tooltip title="Profile" placement="right">
          <IconButton>
            <img
              src={profileIcons}
              alt="Profile"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    // {
    //   id: 2,
    //   label: "Search Candidates",
    //   link: "/app/search",
    //   view: true,
    //   icon: (
    //     <Tooltip title="Search Candidates" placement="right">
    //       <IconButton>
    //         <img
    //           src={search}
    //           alt="candidates"
    //           className={classNames(classes.Icon4)}
    //         />
    //       </IconButton>
    //     </Tooltip>
    //   ),
    // },
  ];
  return (
    <>
      {recruiterItems.map((link) => (
        <SidebarLink
          key={link.id}
          location={location}
          isSidebarOpened={isSidebarOpened}
          {...link}
        />
      ))}
    </>
  );
};

export default EmployeeSidebar;
